var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"filled":"","auto-grow":"","rows":_vm.rows,"label":_vm.itemLabel,"rules":_vm.rules,"hint":_vm.hint,"persistent-hint":_vm.showHint,"clearable":""},on:{"blur":_vm.blur,"click:clear":function () { return this$1.$emit('blur', []); }},model:{value:(_vm.theValue),callback:function ($$v) {_vm.theValue=$$v},expression:"theValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }